export default __webpack_public_path__ + "static/media/line03.62f649ed.jpg";